import PropTypes from "prop-types";
import React, {Component} from "react";
import {Switch, Route, Router} from "react-router-dom";
import {connect} from "react-redux";

import {ActionCreator as ApplicationActionCreator} from "../reducers/application/application";
import {ActionCreator as DataActionCreator, Operation} from "../reducers/data/data";
import {AppRoute} from "../const";
import {ErrorPage} from "./error-page";
import {MainPage} from "./main-page";
import {PoolPage} from "./pool-page";
import {PeriodDataPropType, PoolPropType} from "../prop-types";
import {checkPoolAvailability} from "../utils/utils";
import {getActivePeriodId} from "../reducers/application/selectors";
import {getActivePeriod, getDataError, getPools} from "../reducers/data/selectors";
import {history} from "../history";


class AppComponent extends Component {
  constructor(props) {
    super(props);

    this._renderPoolPage = this._renderPoolPage.bind(this);
    this._changePeriod = this._changePeriod.bind(this);
  }

  componentDidMount() {
    const dataError = this.props.dataError;

    if (!dataError) {
      this._changePeriod();

      history.listen(() => {
        this._changePeriod();
      });
    }
  }

  _changePeriod() {
    const activePeriodId = this.props.activePeriodId;

    const routeParamsString = history.location.search;
    const routeParams = new URLSearchParams(routeParamsString);
    const newPeriodId = routeParams.get(`period`) || ``;

    if (newPeriodId !== activePeriodId) {
      this.props.onPeriodChange(newPeriodId);
    }
  }

  _renderPoolPage(routeProps) {
    const pools = this.props.pools;
    const poolId = routeProps.match.params.id;
    const isPool = checkPoolAvailability(pools, poolId);

    if (isPool) {
      return (
        <PoolPage routeProps={routeProps} />
      );
    }

    return (<ErrorPage dataError={{status: 404}} />);
  }

  render() {
    const dataError = this.props.dataError;
    const isActivePeriod = !!this.props.activePeriod;

    if (dataError || !isActivePeriod) {
      return (
        <ErrorPage dataError={dataError} />
      );
    }

    return (
      <Router history={history}>
        <Switch>
          <Route exact path={AppRoute.MAIN}
            render={() => {
              return (<MainPage />);
            }}
          />

          <Route exact path={AppRoute.POOL}
            render={(routeProps) => this._renderPoolPage(routeProps)}
          />

          <Route exact path={AppRoute.AREA}
            render={(routeProps) => this._renderPoolPage(routeProps)}
          />

          <Route
            render={() => {
              return (<ErrorPage dataError={{status: 404}} />);
            }
            }
          />
        </Switch>
      </Router>
    );
  }
}


AppComponent.propTypes = {
  dataError: PropTypes.object,
  pools: PropTypes.arrayOf(PoolPropType),
  activePeriodId: PropTypes.string,
  activePeriod: PeriodDataPropType,
  onPeriodChange: PropTypes.func.isRequired,
};


const mapStateToProps = (state) => {
  const dataError = getDataError(state);
  let pools = null;
  let activePeriodId = null;
  let activePeriod = null;

  if (!dataError) {
    pools = getPools(state);
    activePeriodId = getActivePeriodId(state);
    activePeriod = getActivePeriod(state);
  }

  return {
    dataError,
    pools,
    activePeriodId,
    activePeriod,
  };
};

const mapDispatchToProps = (dispatch) => ({
  onPeriodChange(newPeriodId) {
    dispatch(ApplicationActionCreator.setActivePeriod(newPeriodId));
    dispatch(DataActionCreator.setDataError(null));
    dispatch(Operation.loadPools(newPeriodId));
  },
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppComponent);


export {
  AppComponent,
  App,
};
